var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ImageIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 53,
    glyphHeight: 35,
    glyphOffsetY: 0
  }), React.createElement("path", {
    d: "M12.619 6.25C12.619 9.70178 9.79418 12.5 6.30952 12.5C2.82487 12.5 0 9.70178 0 6.25C0 2.79822 2.82487 0 6.30952 0C9.79418 0 12.619 2.79822 12.619 6.25Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M0 33.5C0 34.3284 0.677969 35 1.51429 35H51.4857C52.322 35 53 34.3284 53 33.5V21.149C53 20.7349 52.8272 20.3392 52.5225 20.0557L37.4089 5.99201C36.8143 5.43866 35.8839 5.45148 35.305 6.02099L20.2243 20.8573C19.6432 21.429 18.7085 21.4394 18.1146 20.8808L12.9178 15.9931C12.3281 15.4384 11.4014 15.4442 10.8187 16.0062L0.457866 25.9997C0.165123 26.2821 0 26.6697 0 27.0744V33.5Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M12.119 6.25C12.119 9.42118 9.52251 12 6.30952 12C3.09653 12 0.5 9.42118 0.5 6.25C0.5 3.07882 3.09653 0.5 6.30952 0.5C9.52251 0.5 12.119 3.07882 12.119 6.25ZM51.4857 34.5H1.51429C0.949632 34.5 0.5 34.0478 0.5 33.5V27.0744C0.5 26.8062 0.609395 26.5483 0.804983 26.3596L11.1658 16.3661C11.5565 15.9893 12.1797 15.9853 12.5752 16.3573L17.772 21.245C18.5615 21.9875 19.8023 21.9738 20.575 21.2137L35.6557 6.37742C36.0438 5.99563 36.6694 5.98689 37.0683 6.35805L52.1819 20.4217C52.3855 20.6112 52.5 20.8745 52.5 21.149V33.5C52.5 34.0478 52.0504 34.5 51.4857 34.5Z",
    stroke: "strong"
  }));
};
export var ImageIconGlyph = function (props) {
  return React.createElement(ImageIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};